import React from "react"
import {useStateProviderValue} from "../context/StateProvider"

const CvPreview = () => {
	const {state} = useStateProviderValue()
	const [brandingData, setBrandingData] = React.useState(state.branding)
	const [leftSideData, setLeftSideData] = React.useState(state.leftSide)
	const [rightSideData, setRightSideData] = React.useState(state.rightSide)

	//reload branding data
	React.useEffect(() => {
		setBrandingData(state.branding)
		setLeftSideData(state.leftSide)
		setRightSideData(state.rightSide)
	}, [state])

	return (
		<div className="cv-wrapper">
			<div id="cv-a4" className="cv-page">
				{brandingData ? <span></span> : ""}
				<div className="cv-page__left">
					{leftSideData.photo && (
						<img
							className="cv-page__photo"
							src={leftSideData.photo}
							alt="user profile"
						/>
					)}

					<div className="cv-page__left-contact">
						<h2 className="section-title">Contact</h2>
						<p className="text-medium">{leftSideData.phone} </p>
						<p className="text-medium">{leftSideData.email} </p>
						<p className="text-medium">{leftSideData.address} </p>

						{/** website link loop */}
						{leftSideData.websites
							.sort((a, b) => (a.order > b.order ? 1 : -1))
							.map((website) => (
								<div key={website.id} className="cv-page__website">
									{website?.url.includes("http") ? (
										<a target="_blank" rel="noreferrer" href={website?.url}>
											{website.label}
										</a>
									) : (
										<span>{website.label}</span>
									)}
								</div>
							))}
					</div>
					{/** left side section loop */}
					{leftSideData.sections
						.sort((a, b) => (a.order > b.order ? 1 : -1))
						.map((section) => (
							<div key={section.id} className="cv-page__left-section">
								<h2 className="section-title">{section.title}</h2>
								{/** section inner row  */}
								{section.rows
									.sort((a, b) => (a.order > b.order ? 1 : -1))
									.map((row) => (
										<div key={row.id} className="cv-page__website">
											{row?.link.includes("http") ? (
												<a target="_blank" rel="noreferrer" href={row?.link}>
													{row.label}
												</a>
											) : (
												<span>{row.label}</span>
											)}
										</div>
									))}
							</div>
						))}
				</div>
				<div className="cv-page__right">
					<div className="cv-page__right-name-title">
						<h1 className="text-uppercase">{rightSideData.fullName}</h1>
						<h3 className="text-capitalize">{rightSideData.jobTitle}</h3>
					</div>
					<div className="cv-page__right-profile">
						<h2 className="section-title">Profile</h2>
						<p>{rightSideData.profileSummary}</p>
					</div>

					{/** Right side section loop */}
					{rightSideData.sections
						.sort((a, b) => (a.order > b.order ? 1 : -1))
						.map((section) => (
							<div className="cv-page__right-section" key={section.id}>
								<div className="section-title">{section.title}</div>
								{/** section inner row loop */}
								{section.rows
									.sort((a, b) => (a.order > b.order ? 1 : -1))
									.map((row) => (
										<div key={row.id} className="cv-page__right-row">
											<h3 className="text-capitalize">{row.title}</h3>
											<p>{row.subTitle}</p>
											<ul>
												{/** loop detail list for each row */}
												{row.details
													.sort((a, b) => (a.order > b.order ? 1 : -1))
													.map((detail) => (
														<li key={detail.id}>{detail.detail}</li>
													))}
											</ul>
										</div>
									))}
							</div>
						))}
				</div>
			</div>
		</div>
	)
}

export default CvPreview
